import React from 'react';
// import { vertices as verticesF1 } from 'config/f1Info';
// import { vertices as verticesF2 } from 'config/f2Info';
// import { vertices as verticesF3 } from 'config/f3Info';
import f1databse from 'config/f1Info';
import f2databse from 'config/f2Info';
import f3databse from 'config/f3Info';
import { getCachedItem } from 'utils/localStorage';
import { deviceFloorLevel } from 'config/constants';

export default function useGetFloorVertices(floorLevel) {
  const initialMapFloor = React.useCallback(() => getCachedItem(deviceFloorLevel), [])

  const [floorDatabase, setFloorDatabase] = React.useState(f1databse);

  function defineFloorDatabase(level) {
    switch (level) {
      case 1:
        setFloorDatabase(f1databse);
        break;
      case 2:
        setFloorDatabase(f2databse);
        break;
      case 3:
        setFloorDatabase(f3databse);
        break;
      default:
        setFloorDatabase(null);
        break;
    }
  }

  React.useEffect(() => {
    // If there is no cached floor level then the default will be 1
    defineFloorDatabase(initialMapFloor() || 1);
  }, ['init']);

  React.useEffect(() => {
    defineFloorDatabase(floorLevel);
  }, [floorLevel]);

  return floorDatabase;
};